import type { IconSvgObject } from './types';

const SortingZA01Icon: IconSvgObject = [
  ["path", { d: "M4 3H9.5V3.5L4.5 9.5V10H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 20.5L6.5 14H7.5L10 20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 17L17 20L20 17M17 4V19.3912", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SortingZA01Icon;
